import Vue from "vue";
import Vuex from "vuex";
import user from "./user";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    serverUrl: "https://api-sme-prod.zwiz.app/",
    pageid: "176922345693076", //103876431747147
  },
  mutations: {},
  actions: {},
  modules: {
    user,
  },
});
